namespace RioERP.Carts {
    export interface AddToCartRequest extends Serenity.ServiceRequest {
        FranchiseeId?: number;
        ProductId?: number;
        Quantity?: number;
    }
}
